module.exports = __webpack_public_path__ + "static/media/MAIMotion.dffb1092.mp4";